// extracted by mini-css-extract-plugin
export var menuItem = "J_ty d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "J_tz d_W d_bw d_bL";
export var menuMainLink = "J_tB d_fX d_dx";
export var menuLink = "J_tC d_fX d_dx";
export var Link = "J_ss x_ss x_rN x_r6";